import { gql } from '@apollo/client';
import { AssetFragment } from 'graphql/Asset/fragments/AssetFragment';
/**
 * @fragment AccountAssetFragment
 * @since 1.0.0
 */
export const AccountAssetFragment = gql `
  fragment AccountAssetFragment on AccountAsset {
    id

    asset {
      ...AssetFragment
    }

    connection {
      id
      active
      connected
      configs

      relatedOperations {
        id
        name
        type
        options
      }
    }
  }

  ${AssetFragment}
`;
